import { Form, Input } from 'antd';
import { postApi, putApi } from 'apis';
import Buttons from 'components/Global/Buttons';
import { FC, useState } from 'react';
import { toastText } from 'utils/utils';
import styles from './index.module.scss';
import { SideDrawerBodyProps } from './types';

const AddPayPointBody: FC<SideDrawerBodyProps> = (props) => {
	const [loading, setLoading] = useState<boolean>(false);
	const { closeDrawerByAnimation, fetchPayPoint, editSelectedUser } = props;

	const buttons = [
		{
			text: `Cancel`,
			isLoading: false,
			className: 'btn-cancel',
			isSubmit: true,
			disabled: loading,
			onclick: () => {
				closeDrawerByAnimation();
			},
			fontSize: '1.8rem',
			minWidth: '12rem',
			minHeight: '4rem',
		},
		{
			text: `Save`,
			isLoading: loading,
			className: 'btn-blue',
			isSubmit: true,
			disabled: false,
			onclick: () => { },
			fontSize: '1.8rem',
			minWidth: '12rem',
			minHeight: '4rem',
		},
	];
	const handleSubmit = async (values: any) => {
		if (editSelectedUser) {
			let data: any = {
				payPointId: editSelectedUser?.id,
				...values,
			};
			await updatePayPoint(data);
		} else {
			await addPayPoint(values);
		}
	};

	const updatePayPoint = async (categoryCodeData: any) => {
		try {
			setLoading(true);
			const response = await putApi('/payPoint', categoryCodeData);
			fetchPayPoint();
			closeDrawerByAnimation();
			let message =
				response?.data?.message || 'Pay point updated successfully';

			toastText(message, 'success');
		} catch (err: any) {
			const errorMessage =
				err?.response?.data?.message ||
				'Something went wrong in updating pay point';
			toastText(errorMessage, 'error');
		} finally {
			setLoading(false);
		}
	};
	const addPayPoint = async (finalData: any) => {
		try {
			setLoading(true);
			const response = await postApi('/payPoint', finalData);
			fetchPayPoint();
			closeDrawerByAnimation();
			let message =
				response?.data?.message || 'Pay point created successfully';

			toastText(message, 'success');
		} catch (err: any) {
			const errorMessage =
				err?.response?.data?.message ||
				'Something went wrong when creating to pay point';
			toastText(errorMessage, 'error');
		} finally {
			setLoading(false);
		}
	};

	return (
			<div className={styles['side-drawer-body']}>
				<Form
					name="basic"
					className={styles['side-drawer-form']}
					labelCol={{ span: 8 }}
					wrapperCol={{ span: 16 }}
					style={{ maxWidth: 600 }}
					onFinish={handleSubmit}
					initialValues={editSelectedUser}
					autoComplete="off"
				>
					<p className={styles['form-container-head-warning']}>
						<b>
							{' '}
							<sup>*</sup>
						</b>{' '}
						Indicated mandatory fields
					</p>
					<div className={styles['side-drawer-form__inputs']}>
						<label
							className={styles['side-drawer-form__role--label']}
						>
							{'Pay Point'}{' '}
							<span className="required-color">*</span>
						</label>
						<Form.Item
							// className="side-drawer-form__role"
							name={'payPoint'}
							rules={[
								{
									required: true,
									message: 'Please enter the Pay Point',
									validateTrigger: 'onChange',
									validator: (_, value) =>
										value && value.trim() !== ''
											? Promise.resolve()
											: Promise.reject(
												'Please enter value'
											),
								},
								// {
								// 	max: 30,
								// 	message:
								// 		'Pay point length must be less than 30 characters',
								// 	validateTrigger: 'onChange',
								// },
							]}
							wrapperCol={{ span: 24 }}
						>
							<Input
								className="remove-antd-input-effect"
								maxLength={150}
								size="large"
								disabled={false}
								type={'text'}
							// defaultValue={
							// 	userProfileData[item?.name]
							// }
							/>
						</Form.Item>
					</div>
					<div className={styles['side-drawer-form__inputs']}>
						<label
							className={styles['side-drawer-form__role--label']}
						>
							{'Location'}{' '}
							<span className="required-color">*</span>
						</label>
						<Form.Item
							// className="side-drawer-form__role"
							name={'location'}
							rules={[
								{
									required: true,
									message: 'Please enter the Location',
									validateTrigger: 'onChange',
									validator: (_, value) =>
										value && value.trim() !== ''
											? Promise.resolve()
											: Promise.reject(
												'Please enter value'
											),
								},
								// {
								// 	max: 30,
								// 	message:
								// 		'Location length must be less than 30 characters',
								// 	validateTrigger: 'onChange',
								// },
							]}
							wrapperCol={{ span: 24 }}
						>
							<Input
								className="remove-antd-input-effect"
								maxLength={150}
								size="large"
								disabled={false}
								type={'text'}
							// defaultValue={
							// 	userProfileData[item?.name]
							// }
							/>
						</Form.Item>
					</div>
					<div className={styles['side-drawer-form__buttons']}>
						<Form.Item>
							<Buttons buttons={buttons} />
						</Form.Item>
					</div>
				</Form>
			</div>
	);
};

export default AddPayPointBody;
